import styled from "styled-components";

export const NavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;

  color: ${({ theme }) => theme.colors.textColor};
`;
